module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monitor"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "area-list"
  }, _vm._l((_vm.areaList), function(item, index) {
    var _obj;

    return _c('div', {
      key: index,
      staticClass: "item",
      class: ['item', ( _obj = {}, _obj['active'] = index == 2, _obj )]
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "left-item left-item1"
  }, [_vm._v("\n          " + _vm._s(_vm.baseDetailList[_vm.activeItem].baseName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("基地负责人")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].name))])]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].phone))])]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("管理机构")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].company))])]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("基地面积")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].total))])]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("承包时间")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].time))])]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("基地地址")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].region))])])]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('v-lines')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-line', {
    attrs: {
      "tit": "年平均降雨量"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-line', {
    attrs: {
      "tit": "无霜期"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-line', {
    attrs: {
      "tit": "年平均日照时长"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-map', {
    on: {
      "indexChange": _vm.indexChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77a9a640!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInformation/index.vue
// module id = 2049
// module chunks = 2